import type { IncidenceOptionsType } from 'modules/bookkeepers/lib/incidenceOptions'
import { incidenceTrackingBlocked } from 'modules/bookkeepers/lib/incidenceTrackingBlocked'
import { translatedHelpers } from 'modules/bookkeepers/lib/translationHelpers'
import {
  COST_CENTER_CHANGE_TYPES,
  EMPLOYEE_CHANGE_TYPES,
} from 'modules/payroll_bundle/lib/Incidences/Types'

const HIRING = 'hiring'
const TERMINATION = 'termination'
const excludeInEmployeeChangeTypes = [HIRING, TERMINATION]

export const useGetEmployeeIncidenceOptions = (): IncidenceOptionsType[] => {
  const optionTypes = {
    ...EMPLOYEE_CHANGE_TYPES,
    ...COST_CENTER_CHANGE_TYPES,
  }
  const employeeIncidences = Object.keys(optionTypes).flatMap((key: string) => {
    if (excludeInEmployeeChangeTypes.includes(key)) return []

    return {
      id: key,
      name: key,
      identifier: key,
      disabled: incidenceTrackingBlocked(key),
      ...translatedHelpers(key),
    }
  })

  return employeeIncidences
}
